//import "./jquery";
//import "./alpine";

import "./toastr";
import "./echo";
import "./filters";
import "./user-status";
import "./tag-reorder";
//import "./clockpicker";

//import "../css/exposure.css";
//import "./exposure";
//import select2 from "select2";
//select2(jQuery);

//import "./theme-switcher";

//import flatpickr from "flatpickr";
//window.flatpickr = flatpickr;
/*
import "./bootstrap";


import "@left4code/tw-starter/dist/js/svg-loader";
import "@left4code/tw-starter/dist/js/accordion";
import "@left4code/tw-starter/dist/js/alert";
import "@left4code/tw-starter/dist/js/dropdown";
import "@left4code/tw-starter/dist/js/modal";
import "@left4code/tw-starter/dist/js/tab";

/*import 'dropzone';*/

//import "./fancybox";
//import "./toastr";
/*import "./clockpicker";*/
/*
addEventListener("trix-initialize", event => {
  const { toolbarElement } = event.target
  const inputElement = toolbarElement.querySelector("input[name=href]")
  inputElement.type = "text"
  inputElement.pattern = "(https?://|/).+"
  console.log('iniz')
})
*/

/**
 * PWA Service Worker Registration
 */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('✅ Service Worker registered successfully:', registration.scope);
                
                // Check for updates every 60 seconds
                setInterval(() => {
                    registration.update();
                }, 60000);
                
                // Handle service worker updates
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    console.log('🔄 New service worker found, installing...');
                    
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            // New service worker available, show update notification
                            console.log('✨ New version available! Refresh to update.');
                            
                            // Show update notification (you can customize this)
                            if (window.Toastr) {
                                toastr.info('A new version is available. Refresh to update.', 'Update Available', {
                                    timeOut: 0,
                                    extendedTimeOut: 0,
                                    closeButton: true,
                                    onclick: () => {
                                        newWorker.postMessage({ type: 'SKIP_WAITING' });
                                        window.location.reload();
                                    }
                                });
                            }
                        }
                    });
                });
            })
            .catch((error) => {
                console.error('❌ Service Worker registration failed:', error);
            });
        
        // Handle service worker controller change (new version activated)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('🔄 Service Worker controller changed, reloading page...');
            window.location.reload();
        });
    });
}

// Check if app is running as PWA
window.addEventListener('DOMContentLoaded', () => {
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true;
    
    if (isPWA) {
        console.log('📱 Running as PWA');
        document.body.classList.add('pwa-mode');
    } else {
        console.log('🌐 Running as web app');
    }
});
